import { Loading, VideoPause, VideoPlay, Edit } from "@element-plus/icons-vue";
import { SetExamTimeApi } from "@/api/examApi.js";
import { SetVocabularyExamTimeApi, SaveVocabularyStartMsgApi } from "@/api/vocabularyApi.js";
import { ElMessage } from "element-plus";
// import { getTimeText } from "@/assets/js/tool.js";
import { watch, ref, onBeforeUnmount, reactive } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  props: ["examInfo"],
  setup(props, content) {
    let loadingFlag = ref(true);
    let startExamFlag = ref(false);
    let examInfoShow = ref(true);
    let videoStatus = ref("stop");
    let store = useStore();
    let mp3 = require("@/assets/mp3/sample.mp3");
    let route = useRoute();
    let writeTime = 0;
    let vocaMsg = reactive({
      ifJoin: "",
      appName: "",
      vocabValue: ""
    });
    let step = ref(0);
    // 4级45分钟、5级50分钟、6级55分钟、7级65分钟
    switch (props.examInfo.level) {
      case 4:
        writeTime = 45;
        break;
      case 5:
        writeTime = 50;
        break;
      case 6:
        writeTime = 55;
        break;
      case 7:
        writeTime = 65;
        break;
      default:
        writeTime = props.examInfo.totalTime / 60;
        break;
    }
    let skillText = {
      S0: "",
      S1: "检测耳机并调节音量，如音频播放正常，请点击“开始考试”。另外要注意每个音频只能播放一次。",
      S2: "",
      S3: `考试分为“Read and Choose”（选择题）、“Fill in the gaps”（填空题）、“Make sentences”（连词组句）和“Errorcorrection”（改错题）四部分。`,
      S4: "",
      S5: "",
      S9: "考试共分四个部分：听力理解、语法和词汇、阅读理解、改错。"
    };
    //监听数据改变
    watch(props, () => {
      if (props.examInfo.skill) {
        loadingFlag.value = false;
      }
    });
    //开始考试
    function startExam() {
      document.getElementById("audio").pause();
      if (route.meta.trial) {
        examInfoShow.value = false;
        content.emit("start", true);
      } else if (props.examInfo.skill == "S0") {
        if (step.value == 0) {
          step.value = 1;
        } else {
          if (vocaMsg.ifJoin == "" || !vocaMsg.vocabValue && vocaMsg.ifJoin == 1) {
            ElMessage({
              type: "wring",
              showClose: true,
              message: "请填写信息"
            });
            return 0;
          }
          startExamFlag.value = true;
          SetVocabularyExamTimeApi({
            examId: props.examInfo.examId
          }).then(startTimeR => {
            if (startTimeR.status < 400) {
              // if (!startTimeR.data) {
              //   startExam();
              //   return 0;
              // }
              SaveVocabularyStartMsgApi({
                examId: props.examInfo.examId,
                appName: vocaMsg.ifJoin == 1 ? vocaMsg.appName || "未填写" : "未参加",
                vocabValue: vocaMsg.vocabValue || "100"
              }).then(r => {
                if (r.status < 400) {
                  examInfoShow.value = false;
                  content.emit("start", startTimeR.data);
                } else {
                  ElMessage({
                    type: "error",
                    showClose: true,
                    message: r.msg
                  });
                }
              });
            } else {
              ElMessage({
                type: "error",
                showClose: true,
                message: startTimeR.msg
              });
            }
          });
        }
      } else {
        startExamFlag.value = true;
        SetExamTimeApi({
          examIdCon: props.examInfo.examId
        }).then(startTimeR => {
          if (startTimeR.status < 400) {
            examInfoShow.value = false;
            content.emit("start", true);
          } else {
            ElMessage({
              type: "error",
              showClose: true,
              message: startTimeR.msg
            });
          }
        });
      }
    }
    //播放音频
    function audioPlay() {
      document.getElementById("audio").play();
      videoStatus.value = "ing";
    }
    function audioStop() {
      document.getElementById("audio").pause();
    }
    onBeforeUnmount(() => {
      document.getElementById("audio").pause();
    });
    return {
      writeTime,
      route,
      store,
      mp3,
      skillText,
      examInfoShow,
      loadingFlag,
      startExamFlag,
      videoStatus,
      startExam,
      audioPlay,
      audioStop,
      VideoPause,
      Loading,
      VideoPlay,
      Edit,
      step,
      vocaMsg
    };
  }
};